<div
  class="process-headers"
>
  <kpi4me-process-header
    style="flex: 1"
    [preventUpdate]="preventUpdate()"
  ></kpi4me-process-header>
</div>

<div style="display: flex; flex-direction: column">
  <kpi4me-bread-crumb/>
</div>
<p-splitter
  (onResizeStart)="resizeStarted()"
  (onResizeEnd)="resizeEnded()"
  class="main" [panelStyle]="{
    'white-space': 'nowrap',
    'text-overflow': 'ellipsis',
    overflow: 'hidden'
  }"
>
  <ng-template pTemplate>
    <div [class.show-both]="tableTabs().size > 1"
         class="table-wrapper"
    >
      <mat-tab-group
        [selectedIndex]="selectedTableIndex()"
        (selectedIndexChange)="onSelectedTableIndexChange($event)"
        [preserveContent]="false"
        [mat-stretch-tabs]="false"
        (animationDone)="fitColumns()"
        color="warn"
        class="tab-group"
        libTabActivated
      >
        @for (table of tableTabsArray(); track table.tableName) {
          <mat-tab>
            {{pdfOverlay() | json}}
            <ng-template mat-tab-label>
              <mat-icon [svgIcon]="table.icon"/>
            </ng-template>
            <ng-template matTabContent>
              @switch (table.tableName) {
                @case ('clients') {
                  <kpi4me-clients
                    [class.hide-pagination]="selectedClient()"
                    [style.max-height.px]="selectedClient() ? '130' : ''"
                    #clients
                    [fixedPageSize]="customPageSize()"
                  ></kpi4me-clients>
                  @if (selectedClient()) {
                    <kpi4me-carts
                      style="padding-top: 0.5rem"
                      #carts
                      [fixedPageSize]="customPageSize()"
                    ></kpi4me-carts>
                  }
                }
                @case ('documentOutbox') {
                  <kpi4me-document-outbox
                    #documentOutbox
                    [fixedPageSize]="customPageSize()"
                  ></kpi4me-document-outbox>
                }
                @case ('openItems') {
                  <kpi4me-open-items
                    [class.hide-pagination]="selectedInvoice()"
                    [style.max-height.px]="selectedInvoice() ? '130' : ''"
                    #openItems
                    [fixedPageSize]="customPageSize()"
                    (invoiceToggleTriggered)="toggleDocumentDisplay($event)"
                  ></kpi4me-open-items>
                  @if (selectedInvoice()) {
                    <kpi4me-carts
                      style="padding-top: 0.5rem"
                      [fixedPageSize]="customPageSize()"
                    ></kpi4me-carts>
                  }
                }
                @default {
                  <kpi4me-carts
                    [fixedPageSize]="customPageSize()"
                  ></kpi4me-carts>
                }
              }
            </ng-template>
          </mat-tab>
        }
      </mat-tab-group>

<!--      <lib-help-icon style="position: absolute; right: 0; top: 0; z-index:1" (click)="showHelpForTables()"/>-->
    </div>
  </ng-template>

  <ng-template pTemplate>
    <div
      class="details"
    >
      @if (detailsActive()) {
        <kpi4me-cart-details
          #details
          (detailDocumentToggleTriggered)="toggleDocumentDisplay($event)"
        ></kpi4me-cart-details>
      }
    </div>
  </ng-template>
</p-splitter>


